// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25mA4","rootMobile":"styles_rootMobile__3skqr"};